(function () {
  var DEFAULT_SPEED = 80;
  var resizeTimer;

  function resetMarquee(carousel, track) {
    carousel.classList.remove('has-marquee');
    track.classList.remove('is-marquee');
    track.style.removeProperty('animation-duration');
    track.style.removeProperty('--pl-track-width');
    track.style.removeProperty('transform');
    track.querySelectorAll('[data-marquee-clone]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function initMarquee(carousel) {
    var track = carousel.querySelector('.partner-logos__carousel-track');
    if (!track) return;

    resetMarquee(carousel, track);

    var contentWidth = track.scrollWidth;
    if (contentWidth <= carousel.clientWidth) return;

    var speed = parseFloat(carousel.dataset.speed) || DEFAULT_SPEED;
    var originals = Array.from(track.children);
    var slideWidth = track.scrollWidth;

    originals.forEach(function (child) {
      var clone = child.cloneNode(true);
      clone.setAttribute('data-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.style.setProperty('--pl-track-width', '-' + slideWidth + 'px');
    track.style.animationDuration = (slideWidth / speed) + 's';
    carousel.classList.add('has-marquee');
    track.classList.add('is-marquee');
  }

  function resetAll() {
    document.querySelectorAll('.partner-logos__carousel:not(.partner-logos__carousel--grid)').forEach(function (carousel) {
      var track = carousel.querySelector('.partner-logos__carousel-track');
      if (track) resetMarquee(carousel, track);
    });
  }

  function initAll() {
    if (window.innerWidth > 767) return;
    document.querySelectorAll('.partner-logos__carousel:not(.partner-logos__carousel--grid)').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth > 767) {
        resetAll();
      } else {
        initAll();
      }
    }, 200);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (window.innerWidth > 767) return;
    var carousel = e.target.querySelector('.partner-logos__carousel:not(.partner-logos__carousel--grid)');
    if (carousel) initMarquee(carousel);
  });
})();
